import {
  ORGANIZATION_ID,
  SITE_URL,
  WEBSITE_ID,
  toSchemaGraph,
} from "@Pages/Blog/utils/blogSchemaGraph";
import type { BlogCardPost } from "../types";

const BLOG_URL = `${SITE_URL}/blog`;

const uniqueBySlug = (posts: BlogCardPost[]): BlogCardPost[] => {
  const seen = new Set<string>();
  return posts.filter((post) => {
    if (!post.slug || seen.has(post.slug)) return false;
    seen.add(post.slug);
    return true;
  });
};

const getBlogHomeSchema = (
  posts: BlogCardPost[],
  { title, description }: { title: string; description: string },
) => {
  const listedPosts = uniqueBySlug(posts);

  return toSchemaGraph([
    {
      "@type": "CollectionPage",
      "@id": `${BLOG_URL}#webpage`,
      url: BLOG_URL,
      name: title,
      description,
      inLanguage: "en",
      isPartOf: { "@id": WEBSITE_ID },
      publisher: { "@id": ORGANIZATION_ID },
      breadcrumb: { "@id": `${BLOG_URL}#breadcrumb` },
      mainEntity: { "@id": `${BLOG_URL}#itemlist` },
    },
    {
      "@type": "BreadcrumbList",
      "@id": `${BLOG_URL}#breadcrumb`,
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: `${SITE_URL}/` },
        { "@type": "ListItem", position: 2, name: "Blogs" },
      ],
    },
    {
      "@type": "ItemList",
      "@id": `${BLOG_URL}#itemlist`,
      numberOfItems: listedPosts.length,
      itemListElement: listedPosts.map((post, index) => ({
        "@type": "ListItem",
        position: index + 1,
        url: `${BLOG_URL}/${post.slug}`,
      })),
    },
  ]);
};

export default getBlogHomeSchema;
